const flatRoomTypes: { [key: string]: string } = {
  fiveRoom: '5-комнатная',
  fourRoom: '4-комнатная',
  large: 'Многокомнатная',
  oneRoom: '1-комнатная',
  openPlan: 'Своб. план.',
  studio: 'Студия',
  threeRoom: '3-комнатная',
  twoRoom: '2-комнатная',
};

export function getFlatType(flatRoomType: string) {
  return flatRoomTypes[flatRoomType];
}
